/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createWebhusetOrderApiFeaturesCatalogVpsGetResponseFromDiscriminatorValue, type WebhusetOrderApiFeaturesCatalogVpsGetResponse } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /catalog/vps
 */
export interface VpsRequestBuilder extends BaseRequestBuilder<VpsRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<WebhusetOrderApiFeaturesCatalogVpsGetResponse>}
     */
     get(requestConfiguration?: RequestConfiguration<VpsRequestBuilderGetQueryParameters> | undefined) : Promise<WebhusetOrderApiFeaturesCatalogVpsGetResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<VpsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface VpsRequestBuilderGetQueryParameters {
    coupon?: string;
}
/**
 * Uri template for the request builder.
 */
export const VpsRequestBuilderUriTemplate = "{+baseurl}/catalog/vps{?coupon*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const VpsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: VpsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory:  createWebhusetOrderApiFeaturesCatalogVpsGetResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
